import * as React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'

type AddOptionProps = {
  newOption: string
  addDisabled: boolean
  noOptionsError?: string
  addNewOption: () => void
  onChangeNewOption: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void
}

export function AddOption(props: AddOptionProps) {
  const {
    newOption,
    addDisabled,
    addNewOption,
    noOptionsError,
    onChangeNewOption,
  } = props

  const error = noOptionsError !== undefined

  return (
    <Box display="flex" mb={4}>
      <TextField
        error={error}
        value={newOption}
        placeholder="Add item..."
        helperText={noOptionsError}
        onChange={onChangeNewOption}
        sx={{ flexGrow: 1, mr: 1.8 }}
      />

      <div>
        <Button
          color="primary"
          variant="contained"
          onClick={addNewOption}
          disabled={addDisabled}
        >
          Add
        </Button>
      </div>
    </Box>
  )
}
